module.exports = {"340311001":"淮滨街道","340311100":"小蚌埠镇","340311101":"吴小街镇","340311102":"曹老集镇","340311103":"梅桥镇","340311104":"沫河口镇","340311402":"安徽蚌埠淮上经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340311.json
// module id = 1167
// module chunks = 0